import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./Skills.css";

const Skills = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
      },
    },
  };

  const skillCategories = [
    {
      title: "Frontend Development",
      skills: [
        { name: "React", level: 95 },
        { name: "TypeScript", level: 90 },
        { name: "Next.js", level: 85 },
        { name: "JavaScript", level: 95 },
        { name: "HTML/CSS", level: 95 },
      ],
    },
    {
      title: "Backend Development",
      skills: [
        { name: "Express.js", level: 95 },
        { name: "Java Spring Boot", level: 85 },
        { name: "Laravel", level: 90 },
        { name: "Pure PHP", level: 95 },
      ],
    },
    {
      title: "Mobile Development",
      skills: [
        { name: "React Native", level: 60 },        
      ],
    },
    {
      title: "Database & DevOps",
      skills: [
        { name: "MySQL", level: 95 },
        { name: "MongoDB", level: 85 },
        { name: "PostgreSQL", level: 85 },
        { name: "Docker", level: 80 },
        { name: "Git", level: 95 },
      ],
    },
    {
      title: "Hardware & IoT",
      skills: [
        { name: "Arduino", level: 88 },
        { name: "Raspberry Pi", level: 84 },
        { name: "PCB Design", level: 80 },
        { name: "SolidWorks", level: 82 },
        { name: "FPGA (Beginner)", level: 60 },        
      ],
    },
    {
      title: "Desktop Development",
      skills: [
        { name: "Java Swing", level: 88 },
        { name: "JavaFX", level: 85 },
        { name: "PyQt", level: 82 },
        { name: "Tkinter", level: 80 },
      ],
    },
  ];

  return (
    <section id="skills" className="skills section" ref={ref}>
      <div className="skills-container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: -50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <h2>Skills</h2>
        </motion.div>
        <motion.div
          className="skills-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {skillCategories.map((category, index) => (
            <motion.div
              className="skill-category terminal-window"
              key={index}
              variants={itemVariants}
            >
              <div className="terminal-header">
                <div className="terminal-buttons">
                  <span className="terminal-button red"></span>
                  <span className="terminal-button yellow"></span>
                  <span className="terminal-button green"></span>
                </div>
                <div className="terminal-title">
                  /skills/
                  {category.title
                    .toLowerCase()
                    .replace(" & ", "_")
                    .replace(" ", "_")}
                  .log
                </div>
              </div>
              <h3>{category.title}</h3>
              <ul className="skills-list">
                {category.skills.map((skill, i) => (
                  <li className="skill-item" key={i}>
                    <div className="skill-info">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-level-text">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <motion.div
                        className="skill-level"
                        initial={{ width: 0 }}
                        animate={inView ? { width: `${skill.level}%` } : {}}
                        transition={{ duration: 1, delay: 0.5 + i * 0.1 }}
                      ></motion.div>
                    </div>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
